import { IGetDimension } from "../../models/forms/IAddDimension";

const initialDimension: IGetDimension = {
  Id: 0,
  Messages: '',
  MessagesType: '-1',
  Process: [],
  Pixel: 0
}

export default initialDimension;
